var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0H14.5C14.6552 0 14.8084 0.036145 14.9472 0.105573C15.0861 0.175 15.2069 0.275804 15.3 0.4L18 4V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V4L2.7 0.4C2.79315 0.275804 2.91393 0.175 3.05279 0.105573C3.19164 0.036145 3.34475 0 3.5 0ZM16 6H2V18H16V6ZM15.5 4L14 2H4L2.5 4H15.5ZM6 8V10C6 10.7956 6.31607 11.5587 6.87868 12.1213C7.44129 12.6839 8.20435 13 9 13C9.79565 13 10.5587 12.6839 11.1213 12.1213C11.6839 11.5587 12 10.7956 12 10V8H14V10C14 11.3261 13.4732 12.5979 12.5355 13.5355C11.5979 14.4732 10.3261 15 9 15C7.67392 15 6.40215 14.4732 5.46447 13.5355C4.52678 12.5979 4 11.3261 4 10V8H6Z",
    fill: "url(#paint0_linear_74_11865)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_11865",
    x1: -9,
    y1: -7.60002,
    x2: 20.8879,
    y2: -7.07093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57EBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FA3C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/OrderList.31f497b63538e9e659d104f9dc33776d.svg";
export { ForwardRef as ReactComponent };